import { Component, inject, Input, OnInit } from '@angular/core';
import { ResidentsService } from '@modules/universal-billing/residents/residents.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RentType } from '@modules/universal-billing/residents/resident.enum';
import { BasicForm } from '@shared/components/classes/basic.form';
import { ApartmentPipe } from '@common/pipe/apartment.pipe';
import { AutocompleteComponent } from '@shared/components/autocomplete/autocomplete.component';
import { CalendarModule } from '@primeng/calendar';
import { FieldsetComponent } from '@shared/components/fieldset/fieldset.component';
import { InputValidatorDirective } from '@common/directive/input-validator.directive';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Apartment } from '@modules/universal-billing/apartments/apartments.interface';
import { Observable, switchMap } from 'rxjs';
import { formatDate } from '@shared/utils/format-date';

@Component({
  selector: 'app-create-assign-renter',
  standalone: true,
  imports: [
    ApartmentPipe,
    AutocompleteComponent,
    CalendarModule,
    FieldsetComponent,
    InputValidatorDirective,
    NgSelectComponent,
    ReactiveFormsModule,
    TranslatePipe
  ],
  templateUrl: './create-assign-renter.component.html',
  styleUrl: './create-assign-renter.component.scss'
})
export class CreateAssignRenterComponent extends BasicForm<any> implements OnInit {

  @Input({ required: true }) apartment: Apartment;

  _defaultService: ResidentsService = inject(ResidentsService);
  form: FormGroup;

  rentTypes: any;
  public translate = inject(TranslateService);
  dateFields = ['birthDate', 'bankAccountValid'];

  constructor(private fb: FormBuilder) {
    super();
    this.form = this.fb.group({
      code: [null, Validators.required],
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      middleName: [null],
      birthDate: [null, Validators.required],
      idCardNumber: [null, Validators.required],
      socialStatus: [null],
      taxCode: [null],
      bankAccount: [null],
      bankCode: [null],
      apartmentId: [null, Validators.required],
      rentType: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      phoneNumber: [null],
      status: [true],
      startDate: [null, Validators.required],
    });

    this.rentTypes = [RentType.ROOM, RentType.BUILDING, RentType.APARTMENT].map(item => ({
      id: item,
      name: this.translate.instant(`RENT_TYPES.${item}`)
    }));
  }
  ngOnInit() {
    super.ngOnInit();
    this.form.get('apartmentId').setValue(this.apartment?.id);
  }

  submitAction(data: object): Observable<any> {
    return super.submitAction(data)
      .pipe(
        switchMap(({ data }) => {
          const response = {
            startDate: formatDate(this.form.value.startDate),
            apartmentId: this.form.value.apartmentId,
            residentId: data.id
          }
          return this._defaultService.assignResident(response);
        })
      );
  }
}
